/* import __COLOCATED_TEMPLATE__ from './testimonials.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class PracticeWebsiteEditMenuTestimonials extends Component {}
